import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const fetchOrderReports = async (filterData) => {
  const response = await axiosInstance.post("order/search", filterData, {
    headers,
  });
  return response.data;
};

export const fetchOrderById = async (id) => {
  const response = await axiosInstance.get(`order/${id}`, {
    headers,
  });
  return response.data;
};

export const fetchOrderByGuId = async (id) => {
  const response = await axiosInstance.get(`order/by-order-guid/${id}`, {
    headers,
  });
  return response.data;
};

export const fetchOrderShippingAddressByGuid = async (id) => {
  const response = await axiosInstance.get(`order/shipping-address/${id}`, {
    headers,
  });
  return response.data;
};

export const fetchOrderBillingAddressByGuid = async (id) => {
  const response = await axiosInstance.get(`order/billing-address/${id}`, {
    headers,
  });
  return response.data;
};

export const fetchOrderItemsByGuId = async (id) => {
  const response = await axiosInstance.get(`order/item/${id}`, {
    headers,
  });
  return response.data;
};

export const fetchOrderPaymentsByGuId = async (id) => {
  const response = await axiosInstance.get(`order/payments/${id}`, {
    headers,
  });
  return response.data;
};

export const updateTrackingDetails = async (payLoad) => {
  return await axiosInstance.patch(`order/tracking-details`, payLoad, {
    headers,
  });
};
export const pushToShipRocket = async (orderGuid) => {
  return await axiosInstance.patch(`order/${orderGuid}/push-to-shiprocket`, {
    headers,
  });
};
export const cancelOrder = async (id) => {
  return await axiosInstance.patch(`order/${id}/cancel`, {
    headers,
  });
};

export const confirmOrder = async (id) => {
  return await axiosInstance.patch(`order/${id}/confirm`, {
    headers,
  });
};

export const dispatchOrder = async (id) => {
  return await axiosInstance.patch(`order/${id}/dispatch`, {
    headers,
  });
};

export const deliverOrder = async (id) => {
  return await axiosInstance.patch(`order/${id}/deliver`, {
    headers,
  });
};

export const markOrderPaid = async (id) => {
  return await axiosInstance.patch(`order/${id}/mark-paid`, {
    headers,
  });
};
export const deleteOrder = async (id) => {
  return await axiosInstance.delete(`order/${id}`, { headers });
};
